module.exports = __webpack_public_path__ + "static/media/18ECA12.8f830845.jpg";